import { Grid } from '@material-ui/core';
import { ClientDestinationVote } from 'components/ui/ClientDestinationVote';
import { useQueryParams } from 'hooks/useQueryParams';
import React, { memo } from 'react';

export const Vote = memo(() => {
  const params = useQueryParams();
  const notificationId = params.get('cdvNotificationId');

  return (
    <Grid
      container
      direction="row"
      justify="center"
      alignItems="baseline"
    >
      <Grid item sm={12} md={8}>
        <ClientDestinationVote notificationId={notificationId!} />
      </Grid>
    </Grid>
  );
});
